import React from 'react';
import styled from 'styled-components';
import AIWebinarHeroES from './AIWebinarHeroES';
import AIWebinarFeaturesES from './AIWebinarFeaturesES';
import AIWebinarCTAES from './AIWebinarCTAES';

const AIWebinarPageES = () => {
  return (
    <Container>
      <AIWebinarHeroES />
      <AIWebinarFeaturesES />
      <AIWebinarCTAES />
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  background: #0a0e17;
`;

export default AIWebinarPageES; 